import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/common/components/base.component';
import { ButtonTriggerEvent } from 'src/app/common/components/button/button.component';

@Component({
  templateUrl: './input.modal.component.html',
  styleUrls: ['./input.modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InputModalComponent extends BaseComponent {

  data: InputModalData;
  actions: InputModalActions;
  value: string;
  form: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<InputModalComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA)
    data: any) {
    super();

    this.data = Object.assign({}, data.data);
    this.actions = Object.assign({}, data.actions);
    if (this.data.inputModalValue) {
      this.value = this.data.inputModalValue;
    }
  }

  public ngOnInit() {
    this.form = this.formBuilder.group({
      'text': [null],
    });
  }

  public close(): void {
    if (this.actions.cancel) {
      this.actions.cancel();
    }

    this.dialogRef.close();
  }

  public confirm(event: ButtonTriggerEvent) {
    if (this.data.isAsync) {
      let oldFunc = event.complete;
      event.complete = () => {
        oldFunc();

        this.dialogRef.close();
      };

      this.actions.confirm(event, this.value);
    } else {
      this.actions.confirm(event, this.value);
      this.dialogRef.close();
    }
  }
}

export class InputModalActions {
  confirm: (event: ButtonTriggerEvent, data: string) => void;
  cancel?: () => void;
}

export class InputModalData {
  inputModalTitle?: string;
  inputModalHelpText?: string;
  inputModalValue?: string;
  inputModalConfirmButtonText?: string;
  inputModalCancelButtonText?: string;
  isAsync?: boolean;

  constructor(title: string, helpText: string, value: string, confirmBtnText: string, cancelBtnText: string, isAsync: boolean) {
    this.inputModalTitle = title;
    this.inputModalHelpText = helpText;
    this.inputModalValue = value;
    this.inputModalConfirmButtonText = confirmBtnText;
    this.inputModalCancelButtonText = cancelBtnText;
    this.isAsync = isAsync;
  }
}

